import { configureStore } from "@reduxjs/toolkit";
import companySlice from "./companySlice";
import documentsSlice from "./documentsSlice";
import userSlice from "./userSlice";

const store = configureStore({
  reducer: {
    userDetails: userSlice,
    documentsDetails: documentsSlice,
    companyDetails: companySlice,
  },
});

export default store;
